import React ,{ useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { postData, getList } from "../../services/baseServices"
import { toast } from 'react-toastify';
import { getObjectToFormData } from '../../helper/utils'

const getDimension = async(file) =>{
    let reader = new FileReader();
    return new Promise((resolve, reject)=>{ 
        reader.onerror = () =>{
        reader.abort()
        reject(new DOMException('Problem parsing input file'))
        }
        reader.onload = () =>{
        let image = new Image()
        image.src = reader.result;
        image.onload = function(){
            resolve({width: this.width, height:this.height})
        }
        }
        if(file){
        reader.readAsDataURL(file)
        }else{
        resolve({width:0, height:0})
        }

    })
    }

    const FILE_SIZE = 560*1024;
    const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg','image/png']
    const schema = yup.object().shape({
        debit_bank_account_id: yup.string().required('Bank is required field'),
        credit_bank_account_id: yup.string().required('Bank is required field'),
        chalan_no: yup.string().required('Chalan no is required'),
        amount: yup.number().required('Amount is required'),
        image_file: yup.mixed()
            .test("Required", "Chalan image is a required field", (value) => {
                return !value || value.length > 0;
            })
            .test('FileSize', 'Uploaded file is to big, image size not more than 150kb.', (value) =>{
                return  value === null || (value && value[0]?.size <=FILE_SIZE) 
            })
            .test('type', 'Invalid image format, supported image format are .jpg, .jpeg and .png',(value) =>{
                return value === null || (value && SUPPORTED_FORMATS.includes(value[0]?.type))
            }).test('ImageDimension', 'Chalan Image must be 500 x 500 (width x height)', async (value) =>{
                let sizes = await getDimension(value[0])
                let result = (sizes.width <= 900 && sizes.height <= 900)
                return result
            
            })
    });

const PayModal = ({title, show, handleClose, amount, extraParams, supplierId, supplierName}) => {
    const [debitBankList, setDebitBankList] = useState([])
    const [creditBankList, setCrebitBankList] = useState([])
    const [submitting, setSubmitting] = useState(false)
    const { register, handleSubmit, formState:{ errors }, reset } = useForm({
        resolver: yupResolver(schema)
    });

    useEffect(()=> {
        getList("bank_accounts")
        .then(res => {
            if(res?.status_code !== 404)
                setDebitBankList(res)
        })
        .catch(errMsg => {
        })
        getList("bank_accounts",{type: 'Supplier', id: supplierId})
        .then(res => {
            if(res?.status_code !== 404)
                setCrebitBankList(res)
        })
        .catch(errMsg => {
        })
    }, [supplierId])

    const onSubmit = data =>{
        setSubmitting(true)
        let params = {
            credit_bank_account_id: data.credit_bank_account_id,
            debit_bank_account_id: data.debit_bank_account_id,
            amount: data.amount,
            chalan_no: data.chalan_no,
            image_file: data.image_file[0]
        }
        params = Object.assign(extraParams, params)
        params = getObjectToFormData(params)

        postData("bank_transactions/supplier_payment", params)
        .then((res)=>{
            if(res.status_code === 200 || res.status_code === 201) {
                toast.success(res.message);
                handleClose(true)
            } else {
                toast.error(res.message)
            }
            setSubmitting(false)
        })
        .catch(exp =>{
            debugger
            toast.error(exp)
            setSubmitting(false)
        })
    }

    onclose = () => {
        reset({})
        handleClose(false)
    }

    return (
        <>
            <Modal show={show} onHide={onclose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                       {title}
                    </Modal.Title>
                </Modal.Header>
                <form onSubmit = {handleSubmit(onSubmit)}>
                    <Modal.Body className="p-5">
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                <p>Supplier</p>
                            </div>
                            <div className="col-sm-7">
                                <p >{supplierName}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                <p>Amount</p>
                            </div>
                            <div className="col-sm-7">
                                <input 
                                        type="number" 
                                        step="any"
                                        min="1"
                                        max={amount}
                                        defaultValue={amount}
                                        className="form-control" 
                                        {...register('amount')}
                                    />
                                <p className='text-danger' style={{lineHeight:'20px'}}>{errors.amount?.message}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                <p>From Bank <span className="text-danger">*</span></p>
                            </div>
                            <div className="col-sm-7">
                                <select 
                                    name="bank_name" 
                                    className='form-control' 
                                    {...register('debit_bank_account_id')}
                                >
                                    <option value="">--Select Bank--</option>
                                    {
                                        debitBankList?.map((bank, index) =>{
                                            return(
                                                <option value={`${bank.id}`} key={index}>{bank.title}</option>)
                                        }
                                        )
                                    }
                                </select>
                                <p className='text-danger' >{errors.debit_bank_account_id?.message}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                <p>To Bank <span className="text-danger">*</span></p>
                            </div>
                            <div className="col-sm-7">
                                <select 
                                    name="bank_name" 
                                    className='form-control' 
                                    {...register('credit_bank_account_id')}
                                >
                                    <option value="">--Select Bank--</option>
                                    {
                                        creditBankList?.map((bank, index) =>{
                                            return(
                                                <option value={`${bank.id}`} key={index}>{bank.title}</option>)
                                        }
                                        )
                                    }
                                </select>
                                <p className='text-danger' >{errors.credit_bank_account_id?.message}</p>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="col-sm-5">
                                Chalan No <span className="text-danger">*</span>
                            </div>
                            <div className="col-sm-7">
                                <input type="text"
                                        className={'form-control'}
                                        {...register('chalan_no')}
                                        name="chalan_no" placeholder="Enter Chalan No"/>
                                <p className='text-danger' style={{lineHeight:'20px'}}>{errors.chalan_no?.message}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                    Chalan Image <span className="text-danger">*</span>
                            </div>
                            <div className="col-sm-7">
                                <input 
                                    type="file" 
                                    className="form-control-file" 
                                    {...register('image_file')}
                                />
                                <p className='text-danger' style={{lineHeight:'20px'}}>{errors.image_file?.message}</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onclose}>
                            Close
                        </Button>
                        <Button variant="primary" type='submit' disabled={submitting}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default PayModal
